import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { STREAM_UI_CONFIG } from '../../../../consts';
import { TRACK_EMPTY_BAND_RADIUS_PX } from '../../../../stream-track-visual-tokens';
import { HatchedStrip } from './elements';

const TRACK_HEIGHT = STREAM_UI_CONFIG.focusTracksHeight;
const CONTENT_INSET_Y = STREAM_UI_CONFIG.trackContentInsetY;

/**
 * Empty state for the Live Topics track: inset hatched strip with a tooltip
 * explaining that no topics were detected for the range.
 */
export function LiveTopicsEmptyStrip() {
  const { formatMessage } = useIntl();

  return (
    <Tooltip
      title={formatMessage({
        id: 'logger.streamScreen.liveTopics.noTopicsForRange',
        defaultMessage: 'No se detectaron temas en este rango',
      })}
      placement="top"
    >
      <div
        style={{
          position: 'absolute',
          top: CONTENT_INSET_Y,
          left: 0,
          right: 0,
          height: TRACK_HEIGHT - 2 * CONTENT_INSET_Y,
          zIndex: 2,
          borderRadius: TRACK_EMPTY_BAND_RADIUS_PX,
          overflow: 'hidden',
        }}
      >
        <HatchedStrip />
      </div>
    </Tooltip>
  );
}
